import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-settings-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './settings-nav.html',
  styleUrl: './settings-nav.scss'
})
export class SettingsNavComponent {
  @Input() activeItem: string = 'integrations'; // Default to integrations as shown in Figma
  @Output() navigationChange = new EventEmitter<string>();

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  setActive(item: string): void {
    this.activeItem = item;
    this.navigationChange.emit(item);
    
    // Handle navigation based on the selected item
    const botId = this.route.snapshot.paramMap.get('bot_id');
    
    if (botId) {
      switch (item) {
        case 'integrations':
          this.router.navigate(['/store', botId]);
          break;
        case 'api-keys':
          this.router.navigate(['/api-keys', botId]);
          break;
        case 'reports':
          this.router.navigate(['/reports', botId]);
          break;
        // Add other navigation cases as needed
        default:
          break;
      }
    }
  }
}